<div class="flex-full space-between align-items-center base-header-container" #header>
  <div class="header" [class.pointer]="this.sortEnabled()" (click)="this.toggleSort()">
    <div class="header-text"><ng-content></ng-content></div>
  </div>
  <div class="flex-row flex-end">
    @if (this.sortEnabled()) {
      <div class="sort filter-icon" (click)="this.toggleSort()">
        @if (this.sort() === 'asc') {
          <cam-font-icon name="arrow-big-top" type="xs"></cam-font-icon>
        }
        @if (this.sort() === 'desc') {
          <cam-font-icon name="arrow-big-bottom" type="xs"></cam-font-icon>
        }
      </div>
    }

    <div class="filter filter-icon" [class.pointer]="this.filterEnabled()" [class.d-flex]="this.filterActive()">
      @if (this.filterEnabled()) {
        <cam-font-icon name="filter-tool" type="sm" (click)="this.showFilter(header)"></cam-font-icon>
      }
    </div>
  </div>
</div>
